













































































/** @format */

import { Vue, Component, Prop } from 'vue-property-decorator';
import AuthImg from '@/components/auth-img/index.vue';
import { API_SERVER } from '@root/common/config';
import ShowImg from '../show-img/index.vue';
@Component({
  components: {
    AuthImg,
    ShowImg
  }
})
export default class AgreementPage extends Vue {
  @Prop({ default: false }) private value!: boolean;
  @Prop({ default: () => {} }) private modelDate!: object;
  @Prop({ default: () => [] }) private colums!: any[];
  @Prop({ default: 60 }) private width!: number | string;
  private imgBaseUrl = `${API_SERVER.imgBaseUrl}`;
  private defaultImg = `${API_SERVER.defaultImg}`;
  get showReviewModel() {
    return this.value;
  }
  set showReviewModel(value) {
    this.$emit('input', value);
  }
  getEnterImg(index) {
    window.open((this.$refs.enterImg as any)[index].src);
  }
  getExitImg(index) {
    window.open((this.$refs.exitImg as any)[index].src);
  }
}
